import styled, { css } from 'styled-components';
import { B1C, B2C, Themes, MONITOR_SCREENS } from '@cyberint/dsc';
import BG_IMG from './background.png';

const ANCHOR_COLOR = '#3594ff';
const TEXT_COLOR = '#5d6b82';

export const TransWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
`;

export const Header = styled.h1`
  font-size: 40px;
  color: var(--xanthous);
  font-weight: 600;
`;

export const FooterNote = styled(B1C)`
  margin-top: 120px;
`;

export const MessagesWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 0 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: var(--app-infinity-color);
  background-color: var(--app-infinity-bg);
  background-image: url(${BG_IMG});
  background-size: 0;

  ${({ $isError }) =>
    $isError &&
    css`
      background-position: left center;
      background-size: cover;
      color: var(--antiFlashWhite1);

      .dsc-icon-wrapper svg,
      a {
        color: var(--xanthous);
      }

      li {
        margin-bottom: 10px;
        &::marker {
          color: var(--xanthous);
          font-weight: 700;
        }
      }
    `}
`;

export const SingleMsg = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  .dsc-h1 {
    font-size: 30px;
    font-weight: 500;
  }
  .dsc-copyableTitle {
    align-items: flex-end;
  }
  .message-step {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
`;

export const RefreshMsg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoaderWrapper = styled.div`
  div {
    position: unset;
    scale: 110%;
  }
  margin-bottom: 10px;
`;

export const DescriptionWrapper = styled.div`
  padding: 0 60px;
  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    padding: 0 40px;
  }
`;
export const Title = styled.h1`
  font-size: 48px;
  margin-bottom: 32px;
  font-weight: bold;
  color: var(--mainPink);
  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    font-size: 42px;
    margin-bottom: 24px;
  }
`;

export const PhraseContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Phrase = styled.div`
  display: flex;
  gap: 8px;
  font-size: 20px;
  margin-bottom: 38px;
  strong {
    color: var(--black);
  }
  .dsc-icon-wrapper {
    color: var(--mainPink);
  }
  .title-description {
    margin-bottom: 20px;
  }

  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    font-size: 18px;
    margin-bottom: 24px;
  }
`;

export const FormTitle = styled.h2`
  margin-bottom: 12px;
  color: var(--app-infinity-color);
  font-size: 32px;
  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    margin-bottom: 5px;
  }
`;

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 0 20px 0;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: var(--white);
  font-size: 24px;
  svg path {
    stroke-width: 1;
  }
`;

export const DemoPageWrapper = styled.div.attrs({ className: Themes.LIGHT })`
  background-color: var(--app-infinity-bg);
  color: ${TEXT_COLOR};
  display: flex;
  flex-direction: row;
  gap: 50px;
  width: 100%;
  height: 100%;
  .dsc-fieldLabel {
    color: ${TEXT_COLOR};
  }
  .MuiInputBase-input {
    color: var(--black);
  }
  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    gap: 30px;
  }
`;

export const DescriptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 56%;
  min-width: 750px;
  background-color: var(--white);
  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    min-width: 650px;
  }
`;

export const DemoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 46%;
`;

export const DemoFormWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  gap: 24px;
  width: 400px;
  min-height: 700px;
  color: ${({ $done }) => ($done ? 'var(--white)' : 'var(--app-infinity-color)')};
  background-color: ${({ $done }) => ($done ? 'var(--mainPink)' : 'var(--white)')};
  box-shadow: 0px 1px 8px 0px rgba(21, 41, 75, 0.2);
  border-radius: 20px;
  z-index: 10;
  box-sizing: border-box;

  .dsc-fieldControl {
    gap: 5px;
  }

  .dsc-button {
    margin-top: 12px;
    background: var(--mainPink);
    border: none;
    border-radius: 8px;
    color: var(--white);
    font-weight: 700;
    width: 320px;
    div,
    span {
      text-transform: none;
    }
    &:hover:not([disabled]) {
      background: var(--mainPink);
      color: var(--white);
      scale: 1.05;
    }
  }
  @media ${MONITOR_SCREENS.monitor.lte_medium} {
    gap: 16px;
    width: 350px;
    min-height: 600px;
    .dsc-button {
      margin-top: 5px;
    }
  }
`;
export const Note = styled.div`
  font-size: 12px;
  width: 320px;
  margin: 5px 0;
  line-height: 16px;
  letter-spacing: 0.2px;
  a {
    color: ${ANCHOR_COLOR};
  }
`;

export const Error = styled(B2C)`
  width: 320px;
  margin: 10px 0;
  color: var(--error);
  display: flex;
  gap: 5px;
`;

export const ClickHere = styled.a`
  color: white;
  font-size: 36px;
  text-decoration: unset;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
